export const COURSE = "live[course]";
export const LIVE_FEEDBACK_ANSWERS = "live[liveFeedbackAnswers]";
export const LIVE_FEEDBACK_QUESTIONS = "live[liveFeedbackQuestions]";
export const LIVE_CHANNEL = "live[liveChannel]";
export const LIVE_SESSION = "live[liveSession]";
export const LIVE_SESSIONS_LIST = "live[liveSessionsList]";
export const LIVE_SESSION_SCHEDULE_PAGE = "live[liveSessionSchedulePage]";
export const LIVE_SESSIONS_LIST_PAGE = "live[liveSessionsListPage]";
export const LIVE_STREAM = "live[liveStream]";
export const LIVE_PAGE = "live[livePage]";
export const LIVE_SETUP = "live[liveSetup]";
export const USER = "live[user]";
export const USER_LIVE_SESSION = "live[userLiveSession]";
export const PUBNUB_CREDENTIALS = "live[pubnubCredentials]";
